import { atom } from "recoil";

export const recoilSwitchState = atom({
  key: "recoilSwitchState",
  default: false,
});
